export const COMERCIALOFFER_ID_PRO = 9000;
export const RELEVANT_DOCUMENTATION_ID_PRO = 17318;
export const NORMATIVE_COMPLIANCE_ID_PRO = 21051;
export const CORPORATE_IMAGE_ID_PRO = 21121;
export const PREVENTION_SSMM_ID_PRO = 21151;
export const DATA_PROTECTION_ID_PRO = 21066;
